$body = $("body");

L.Icon.Default.prototype.options['iconUrl'] = 'marker-icon.png';
L.Icon.Default.prototype.options['iconRetinaUrl'] = 'marker-icon.png';

var properties = {
    defaultTitle: '',
    currentURL: '',
    currentID: '',
    currentType: '',
    previousURL: '',
    savedURL: '',
    userLanguage: 'en',
    username: '',
    resetOnLoad: true,
    popPages: ['contact', 'view', 'legend', 'legend-bikeway', 'legend-ped', 'legend-transit', 'nearby', 'privacy-policy', 'add-feature'],
    loadHash: '',
    loadHashID: '',
    submittedComments: [],
    // submittedComments: JSON.parse('[{"location": "test 1", "feature_id":"334","name":"","email":"","corridor_one":"2","corridor_two":"2","corridor_alt":"1","corridor_alt_2":"2","corridor_alt_reason":"asdf","mode":"corridors","type":"bike","uid":""},{"feature_id":"878","name":"","email":"","ped_one":"3","ped_two":"3","mode":"pedestrian","type":"pedestrian","uid":""},{"feature_id":"880","name":"","email":"","ped_one":"3","ped_two":"1","mode":"pedestrian","type":"pedestrian","uid":""},{"feature_id":"361","name":"","email":"","corridor_one":"3","corridor_two":"2","corridor_alt":"3","corridor_alt_2":"2","corridor_alt_reason":"asdf","mode":"corridors","type":"bike","uid":""}]'),
    commentsToggle: false
}

//Map Initial Variables
var map;
var mapData = {
    centerLocation: [45.521149, -122.676081],
    baseLayerI: '',
    baseLayerS: '',
    drawnItemsLayer: '',
    inputMarker: '',
    featuresURL: 'config/comments.php?/suggestions/',
    likesURL: 'config/comments.php?/likes/',
    commentsURL: 'config/comments.php?/comments/',
    surveyURL: 'config/comments.php?/survey/',
    reviewsURL: 'config/comments.php?/reviews/',
    nearbyRoutes: {},
    features: {},
    featuresData: {},
    lineStringLayer: {},
    pointsLayer: {},
    selectLayer: L.featureGroup(),
    userLocationLayer: {},
    ls: {},
    geoJSONLayer: '',
    geoJSONLayers: {},
    geoJSON: {},
    geoJSONData: {
        bike: {},
        pedestrian: {}
    },
    geoJSONList:{
        pedestrian: [],
        bike: [],
    },
    pvlk: {}
};

$(document).on({
    ajaxStart: function() {
        $body.addClass("loading");
    },
    ajaxStop: function() {
        $body.removeClass("loading");
    },
    ajaxError: function() {
        $body.removeClass('loading');
    }
});

//Load
$(document).ready(function() {

    $('.controls').hide();

    //Set Default Title
    properties.defaultTitle = $(document).find("title").text();

    $.ajaxSetup({
        // Disable caching of AJAX responses
        cache: false,
        beforeSend: function(jqXHR, settings) {
            if (settings.url.match(/\.php\/./i) !== null) {
                settings.url = settings.url.replace(/\.php\//i, '.php?/');
            }
        }
    });

    var lang = getUrlParameter('lang');
    if (lang == 'en'){
        properties.userLanguage = lang;
        createCookie('lang', lang, 100);
    }

    function hashGrab() {
        var hash = window.location.hash.substring(1).split('/')[1];
        $('#content-root').removeClass('large white-bg primary-bg secondary-bg grey-bg background-img');
        $('body').removeClass('large white-bg primary-bg secondary-bg grey-bg');
        // $('.modal').remove();
        loadPage(hash);
        _gaq.push(['_trackPageview', hash]);
    }

    // Bind an event to window.onhashchange that, when the hash changes, gets the
    // hash and adds the class "selected" to any matching nav link.
    $(window).on('hashchange', function() {
        if (properties.currentURL){
            hashGrab();
        }
    })
    //initial Load
    function do_initial_load () {
        if (properties.resetOnLoad === true){
            // properties.loadHash = window.location.hash.substring(1).split('/')[1];
            // properties.loadHashID = window.location.hash.substring(2).split('/')[1];
            window.location.hash = "#/";
        }

        //Load Map
        map = L.map("map", {
            zoomControl: true,
            minZoom: 0
        }).setView(mapData.centerLocation, 15);

        map.zoomControl.setPosition('bottomright');
        map.attributionControl.addAttribution("Alta Planning + Design | <a href='#/privacy-policy'>Privacy Policy</a>");
        
        // mapbox://styles/altaburlingame/ckb8ecqjl09ci1io9izgfp8r7
        // ckb8e4b6l09211io2uexfnj98
        mapData.baseLayerI = L.tileLayer('https://api.mapbox.com/styles/v1/altaburlingame/ckb8ecqjl09ci1io9izgfp8r7/tiles/256/{z}/{x}/{y}?access_token=pk.eyJ1IjoiYWx0YWJ1cmxpbmdhbWUiLCJhIjoiY2szaG1kZml4MGUxbjNjcW42bXNhdTlkMSJ9.CZssopmbPgoTAZt_4dLcSQ');
        mapData.baseLayerS = L.tileLayer('https://api.mapbox.com/styles/v1/altapbot/cjhw5aw210ibr2smpoeyl1tx7/tiles/256/{z}/{x}/{y}?access_token=pk.eyJ1IjoiYWx0YXBib3QiLCJhIjoiY2plZjZvNTY1MmNqYzJxbGVmczZzcHc5MSJ9.adIgUWELgjIkJCRSN1xXDg', {});

        map.addLayer(mapData.baseLayerI);

        //Set Main Layers
        mapData.selectLayer.addTo(map);
        mapData.rollOverLayer = L.featureGroup().addTo(map);

        $.get("data/burlingame/boundaries.json", function(resp) {
          mapData.geoJSON.cityBounds = new L.geoJSON(resp,{
            clickable: false,
            style: {
              color: '#212F3F',
              weight: 3,
              opacity: .8,
              fillOpacity: 0,
              className: "city-bounds"
            }
          })
          mapData.geoJSON.cityBounds.addTo(map);
          map.fitBounds(mapData.geoJSON.cityBounds.getBounds());
        });

        $.get("data/burlingame/ex_class1.json", function(resp) {
          mapData.geoJSON.existing_class1 = new L.geoJSON(resp,{
              clickable: false,
              style: {
                  weight: 3,
                  className: "existing existing-class1"
              }
          })

          mapData.geoJSON.existing_class1.addTo(map);
        });

        $.get("data/burlingame/ex_class2.json", function(resp) {
          mapData.geoJSON.existing_class2 = new L.geoJSON(resp,{
              clickable: false,
              style: {
                  weight: 3,
                  className: "existing existing-class2"
              }
          })

          mapData.geoJSON.existing_class2.addTo(map);
        });

        $.get("data/burlingame/ex_class2b.json", function(resp) {
          mapData.geoJSON.existing_class2b = new L.geoJSON(resp,{
              clickable: false,
              style: {
                  weight: 3,
                  className: "existing existing-class2b"
              }
          })

          mapData.geoJSON.existing_class2b.addTo(map);
        });

        $.get("data/burlingame/ex_class3.json", function(resp) {
          mapData.geoJSON.existing_class3 = new L.geoJSON(resp,{
              clickable: false,
              style: {
                  weight: 3,
                  className: "existing existing-class3"
              }
          })

          mapData.geoJSON.existing_class3.addTo(map);
        });


        mapData.userLocationLayer = L.featureGroup().addTo(map);
        mapData.geoJSONLayer = L.featureGroup().addTo(map);
        mapData.lineStringLayer = L.featureGroup().addTo(map);
        mapData.pointsLayer = new L.markerClusterGroup({
            iconCreateFunction: function(cluster) {
                return L.pointIcon({
                    name: cluster.getChildCount(),
                    cluster: true,
                    iconUrl: "img/marker-cluster.png",
                    iconSize: new L.Point(50, 50),
                    iconAnchor: new L.Point(25, 25),
                    shadowUrl: ""
                });
            },
            showCoverageOnHover: false
        }).addTo(map);
        mapData.drawnItemsLayer = L.featureGroup().addTo(map);

        //Set Icons

        L.PointIcon = L.Icon.extend({
            options: {
                iconUrl: "img/marker.png",
                shadowUrl: "img/marker-shadow.png",
                iconSize: [ 40, 51 ],
                shadowSize: [ 40, 6 ],
                cluster: false,
                iconAnchor: [ 20, 51 ],
                shadowAnchor: [ 20, 0 ],
                popupAnchor: [ 0, -55 ],
                imageIcon: "",
                name: "",
                className: "points-icons"
            },
            createIcon: function() {
                var div = document.createElement("div");
                var marker = this._createImg(this.options["iconUrl"]);
                var numdiv = document.createElement("div");
                numdiv.innerHTML = this.options["name"] || "";
                if (this.options["cluster"]) {
                    numdiv.setAttribute("class", "ttRoute-map-cluster");
                    numdiv.setAttribute("title", "Click to expand");
                }
                div.appendChild(marker);
                div.appendChild(numdiv);
                this._setIconStyles(div, "icon");
                return div;
            }
        });

        mapData.inputMarker = L.icon({
            iconUrl: "img/input-marker.png",
            shadowUrl: "img/input-marker-shadow.png",
            iconSize: [ 80, 97 ],
            iconAnchor: [ 40, 97 ],
            shadowSize: [ 88, 67 ],
            shadowAnchor: [ 21, 67 ],
            className: "input-marker"
        });

        //Setup Draw

        if (!mapData.drawControl){
            mapData.drawControl = new L.Control.Draw({
                edit: false,
                draw: {
                    polyline: {
                        repeatMode: false,
                        shapeOptions: {
                            stroke: true,
                            color: "#8305be",
                            weight: 4,
                            opacity: 1,
                            fill: false,
                            clickable: false
                        }
                    },
                    polygon: false,
                    circle: false,
                    rectangle: false,
                    marker: {
                        repeatMode: false,
                        icon: mapData.inputMarker
                    }
                }
            });


            mapData.drawControl.marker = new L.Draw.Marker(map, mapData.drawControl.options.draw.marker);
            mapData.drawControl.polyline = new L.Draw.Polyline(map, mapData.drawControl.options.draw.polyline);
        }


        //Form Validator
        webshims.setOptions('forms', {
            lazyCustomMessages: true,
            iVal: {
                handleBubble: 'hide', // defaults: true. true (bubble and focus first invalid element) | false (no focus and no bubble) | 'hide' (no bubble, but focus first invalid element)
                fx: 'fade', //defaults 'slide' or 'fade'
                sel: '.ws-validate', // simple selector for the form element, setting this to false, will remove this feature
                fieldWrapper: ':not(span, label, em, strong, b, i, mark, p)'
            }
        });
        webshims.polyfill('forms');
        webshim.activeLang(properties.userLanguage); //set locale to en
        
        hashGrab();
    }

    window.initial_load = false;

    $(window).on('load', function(){
        if (!window.initial_load) {
            window.initial_load = true;
            do_initial_load();
        }
    });

    setTimeout(function(){
        if (!window.initial_load) {
            $(window).trigger('load');
        }
    }, 2000);

});


//Main Controllers
var resizeTimer;
var invalidateMap = function(){
    try {
      map.invalidateSize();
    } catch (e) {
    }
};
var resizeMap = function(){
    var width = ($('#map').hasClass('swipe') === false || $('#map').hasClass('noswipe') === true) ? ($(window).width() - 380) : '100%';
    $('#map').width(width);
    invalidateMap();
};

$(window).on('resize', function(e) {
  clearTimeout(resizeTimer);
  resizeTimer = setTimeout(function() { 
    resizeMap();         
  }, 150);
});

$( ".control-user-input" ).click(function() {
  var hide = $(this).hasClass('removed');
  if (hide){
    $(this).text('Hide All Comments');
    $.each(mapData.features, function(index, value) {
        if (this instanceof L.Marker) {
            mapData.pointsLayer.addLayer(this);
        } else if (this instanceof L.Path) {
            mapData.lineStringLayer.addLayer(this);
        }
    });

  }
  else{
    $(this).text('Show All Comments');
    mapData.pointsLayer.clearLayers();
    mapData.lineStringLayer.clearLayers();
  }
  $(this).toggleClass('removed');
});


$( ".base-toggle" ).click(function() {
  var sat = $(this).hasClass('satellite');
  if (sat){
    map.removeLayer(mapData.baseLayerS);
    map.addLayer(mapData.baseLayerI);
  }
  else{

    map.removeLayer(mapData.baseLayerI);
    map.addLayer(mapData.baseLayerS);

  }
  $(this).toggleClass('satellite');
});

$( ".menu-toggle" ).click(function() {
  $('.controls').toggleClass('toggle-open');
});

$( ".location-toggle" ).click(function() {
    location_feature_handler.startLocation();
});

function getUrlParameter(sParam) {
    var sPageURL = decodeURIComponent(window.location.search.substring(1)),
        sURLVariables = sPageURL.split('&'),
        sParameterName,
        i;

    for (i = 0; i < sURLVariables.length; i++) {
        sParameterName = sURLVariables[i].split('=');

        if (sParameterName[0] === sParam) {
            return sParameterName[1] === undefined ? true : sParameterName[1].replace('/', '');
        }
    }
};

function createCookie(cname,value,days) {
    if (days) {
        var date = new Date();
        date.setTime(date.getTime()+(days*24*60*60*1000));
        var expires = "; expires="+date.toGMTString();
    }
    else var expires = "";
    document.cookie = cname+"="+value+expires+"; path=/";
}

function getCookie(cname) {
    var name = cname + "=";
    var ca = document.cookie.split(';');
    for(var i = 0; i <ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) == ' ') {
            c = c.substring(1);
        }
        if (c.indexOf(name) == 0) {
            return c.substring(name.length, c.length);
        }
    }
    return "";
}

function loadPage(hash) {

    $('#content-root, #map').removeClass('noswipe');
    
    
    if ($.inArray(properties.currentURL, properties.popPages) == -1){
        properties.previousURL = properties.currentURL;
    }

    if (hash == '' || hash == undefined) {
        hash = 'home';
    }

    $('.controls').removeClass('toggle-open');
    home_handler.scrollTop();

    $('a[data-open-modal]').click(function(e){
      //
      var _target = $(this).data().openModal;
      console.log(_target);
      $(_target).modal({
        clickClose: false
      });

    });

    $("#content-root").load("templates/" + properties.userLanguage + "/" + hash + ".html", function(responseText, textStatus, req) {
        var loaded = function(){
            //Global onLoad Functions For Pages
            $('.content-arrow').click(function(event) {
                $('#content-root, #map').toggleClass('swipe');
                if ($('#content-root').hasClass('swipe') == true){
                    home_handler.scrollTop();
                }
                else {
                    home_handler.scrollContent();
                }
                setTimeout(resizeMap, 150);
                return false;
            });

            $('.controls a').each(function() {
                var that = $(this);
                var control = that.children('.control');
                control[that.attr('href') === "#/" + hash ? 'addClass' : 'removeClass']('active');
            });
            
            resizeMap();
        };

        if (textStatus == "error") {
            properties.currentURL = '404';
            $("#content-root").load("templates/" + properties.userLanguage + "/404.html", function() {
                loaded();
            });
        } else {
            properties.currentURL = hash;
            var handler = hash.replace(/-/g, '_') + '_handler';
            if (window[handler]){
                var handler = window[handler];
                
                //Change Page Title
                document.title = handler.properties.title || properties.defaultTitle;
                //Grab events
                handler.events();
            }
            loaded();
        }
    });

}
